import { isPhoneNumberValid } from 'utils/phoneNumber';
import { RequiredErrorMessage, zNonEmptyString } from 'utils/validators/zodHelpers';
import { z } from 'zod';

const baseSchema = z.object({
  name: z.string().optional(),
  officeName: z.string().optional(),
  phone: z
    .string(RequiredErrorMessage)
    .optional()
    .refine(
      d => {
        if (!d) return true;
        return isPhoneNumberValid(d);
      },
      { message: 'Invalid phone number' },
    ),
  website: z.string().optional(),
  npi: z.string().optional(),
});

const optionalSchema = baseSchema.extend({
  physicianOrderRequired: z.literal(false),
});

// Export the required schema for reuse in form-level validation (Juan's suggestion)
export const requiredPCPSchema = baseSchema.extend({
  physicianOrderRequired: z.literal(true),
  name: zNonEmptyString,
  officeName: zNonEmptyString,
});

// Make PCP fields optional at schema level - validation will be handled at form level
const conditionalRequiredSchema = baseSchema.extend({
  physicianOrderRequired: z.literal(true),
  name: z.string().optional(), // Made optional - will be validated conditionally
  officeName: z.string().optional(), // Made optional - will be validated conditionally
});

export const PCPInfoSchema = z.discriminatedUnion('physicianOrderRequired', [optionalSchema, conditionalRequiredSchema]);
